

























































































import ModalMixin from '@/mixins/modal.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { i18n } from '@/i18n';

@Component
export default class ChangeCustomerModal extends Mixins(ModalMixin) {
  @Prop() orderId!: string;

  form: CrsForm<'invoices', 'update'> = this.$crsForm('invoices', 'update', {
    type: 'INDIVIDUAL',
    title: '',
    taxAdministration: '',
    taxNumber: '',
    address: {
      line1: '',
      line2: '',
    },
  });

  get invoiceAddressValidators() {
    return {
      country: {
        hasError: this.form.hasError('customer.address.country'),
        message: this.form.getError('customer.address.country'),
      },
      province: {
        hasError: this.form.hasError('customer.address.province'),
        message: this.form.getError('customer.address.province'),
      },
      district: {
        hasError: this.form.hasError('customer.address.district'),
        message: this.form.getError('customer.address.district'),
      },
    };
  }

  get invoiceTypeOptions() {
    return [
      { label: i18n.t('GENERAL.INDIVIDUAL'), value: 'INDIVIDUAL' },
      { label: i18n.t('GENERAL.CORPORATE'), value: 'CORPORATE' },
    ];
  }

  async getForm() {
    return compass.do('invoices', 'findOne', { params: { invoiceId: this.id } });
  }

  created() {
    this.$on('update-data', () => {
      compass
        .do('orders', 'update', {
          params: {
            orderId: this.orderId,
          },
          data: {
            type: 'CHANGE',
          },
        })
        .then(() => this.$emit('update-complete'));
    });
  }
}
